//pages
import Index from '@/views/pages/administration/Index.vue'
import Store from '@/views/pages/administration/store/Store.vue'
import Zone from '@/views/pages/administration/zone/Zone.vue'
import AdminTable from '@/views/pages/administration/adminTable/Index.vue'
import TypeDocument from '@/views/pages/administration/typeDocument/TypeDocument.vue'
import Referrals from '@/views/pages/administration/referrals/Referrals.vue'
import layouts from '@/layout'

export default {
  path: 'administration',
  name: 'Administración',
  component: Index,
  redirect: {
    path: '/store',
    name: 'store'
  },
  icon: 'progress-wrench',
  auth: true,
  meta: {
    nav: true,
    roles: ['admin']
  },
  children: [
    // {
    //   path: '/zone',
    //   name: 'Zonas',
    //   component: Zone,
    //   meta: {
    //     nav: true,
    //     layout: layouts.navLeft,
    //     roles: ['admin'],
    //     icon: 'flag-triangle',
    //   }
    // },
    {
      path: '/store',
      name: 'Sucursales',
      component: Store,
      meta: {
        nav: true,
        layout: layouts.navLeft,
        roles: ['admin'],
        icon: 'store',
      }
    },
    // {
    //   path: '/type_document',
    //   name: 'Tipo Documento',
    //   component: TypeDocument,
    //   meta: {
    //     nav: true,
    //     layout: layouts.navLeft,
    //     roles: ['admin'],
    //     icon: 'account-card-details-outline',
    //   }
    // },
    // {
    //   path: '/referrals',
    //   name: 'Remisiones',
    //   component: Referrals,
    //   meta: {
    //     nav: true,
    //     layout: layouts.navLeft,
    //     roles: ['admin'],
    //     icon: 'swap-horizontal',
    //   }
    // }
  ]
}